module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/august-d05d480e376890d73fdd1bd4fa221a79.png";